var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg01Screaning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x30_1-screening_2_"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none"
    },
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.0023,
    y1: 18.1524,
    x2: 22.2342,
    y2: 18.1524
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#07B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    style: {
      stopColor: "#0999D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    style: {
      stopColor: "#0993D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9506,
    style: {
      stopColor: "#0B83D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B7DD9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M17,14l4.6,4.6c0.8,0.8,0.8,2.2,0,3l0,0c-0.8,0.8-2.2,0.8-3,0L14,17"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#222222"
    },
    d: "M16,4.5c-2.5-2.4-6.1-3.1-9.2-1.6c-3.1,1.4-5,4.8-4.7,8.2c0.3,3.4,2.8,6.2,6.1,7.1 c3.3,0.9,6.9-0.5,8.8-3.3C19.2,11.6,18.7,7.3,16,4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M15.3,15.4c-2.8,2.8-7.4,2.8-10.2,0c-2.8-2.8-2.8-7.4,0-10.2c2.8-2.8,7.4-2.7,10.2,0 C18.1,8,18.2,12.5,15.3,15.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.8451,
    y1: 10.2537,
    x2: 13.6133,
    y2: 10.2537
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#07B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    style: {
      stopColor: "#0999D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    style: {
      stopColor: "#0993D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9506,
    style: {
      stopColor: "#0B83D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B7DD9"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6.8,
    y: 6.9,
    style: {
      fill: "url(#SVGID_2_)"
    },
    width: 6.8,
    height: 6.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.8,
    y: 7.8,
    style: {
      fill: "#FFFFFF"
    },
    width: 4.8,
    height: 4.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.404,
    y1: 10.2633,
    x2: 11.0543,
    y2: 10.2633
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#07B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    style: {
      stopColor: "#0999D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    style: {
      stopColor: "#0993D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9506,
    style: {
      stopColor: "#0B83D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B7DD9"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    cx: 10.2,
    cy: 10.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.3085,
    y1: 8.5419,
    x2: 8.3606,
    y2: 12.0886
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#07B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    style: {
      stopColor: "#0999D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    style: {
      stopColor: "#0993D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9506,
    style: {
      stopColor: "#0B83D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B7DD9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M6.7,10.7c0.4,0,0.8,0,1.1,0c0.6,0,0.6-1,0-1c-0.4,0-0.8,0-1.1,0C6.1,9.8,6.1,10.7,6.7,10.7 L6.7,10.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.5635,
    y1: 10.2382,
    x2: 13.7032,
    y2: 10.2382
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#07B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    style: {
      stopColor: "#0999D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    style: {
      stopColor: "#0993D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9506,
    style: {
      stopColor: "#0B83D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B7DD9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M12.6,10.7c0.4,0,0.8,0,1.1,0c0.6,0,0.6-1,0-1c-0.4,0-0.8,0-1.1,0 C11.9,9.8,11.9,10.7,12.6,10.7L12.6,10.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.7317,
    y1: 13.1599,
    x2: 10.6917,
    y2: 13.1599
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#07B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    style: {
      stopColor: "#0999D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    style: {
      stopColor: "#0993D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9506,
    style: {
      stopColor: "#0B83D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B7DD9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "M10.7,13.7c0-0.4,0-0.8,0-1.1c0-0.6-1-0.6-1,0c0,0.4,0,0.8,0,1.1 C9.7,14.3,10.7,14.3,10.7,13.7L10.7,13.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 9.7317,
    y1: 7.3166,
    x2: 10.6917,
    y2: 7.3166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#07B1E7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6612,
    style: {
      stopColor: "#0999D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7878,
    style: {
      stopColor: "#0993D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9506,
    style: {
      stopColor: "#0B83D8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B7DD9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    d: "M10.7,7.9c0-0.4,0-0.8,0-1.1c0-0.6-1-0.6-1,0c0,0.4,0,0.8,0,1.1C9.7,8.5,10.7,8.5,10.7,7.9 L10.7,7.9z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01Screaning);
export default __webpack_public_path__ + "static/media/01-screaning.8280083f964e9d94ac9762f5a93e9504.svg";
export { ForwardRef as ReactComponent };